import { render } from "./icon.md?vue&type=template&id=4619d670"
import script from "./icon.md?vue&type=script&lang=js"
export * from "./icon.md?vue&type=script&lang=js"
script.render = render

export default script